import moment from 'moment/moment';

export const compareSpecialDates = (startDate) => {
  const blackFriday = moment('2024-11-29', 'YYYY-MM-DD');

  if (startDate.isSame(blackFriday, 'day')) {
    return 'Black Friday';
  }

  return null;
};